import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PaginatedContextData, PaginatedData } from 'src/app/shared/contexts/asyncData';

import { LocalVictoriousPetitions } from './api.graphql';
import type { LocalVictoriousPetitionsQuery, LocalVictoriousPetitionsQueryVariables } from './api.graphql';
import type { LocalVictoriousPetitionsItem } from './types';

type LocalVictoriousPetitionsApiData = PaginatedData<
	LocalVictoriousPetitionsItem,
	{
		totalCount: number;
		totalCountLocalized: string;
	}
>;

export type LocalVictoriousPetitionsData = PaginatedContextData<LocalVictoriousPetitionsApiData>;

async function getData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
	cursor?: string,
): Promise<LocalVictoriousPetitionsApiData> {
	const { data } = await fetch<LocalVictoriousPetitionsQuery, LocalVictoriousPetitionsQueryVariables>({
		query: LocalVictoriousPetitions,
		variables: { slug, cursor: cursor ?? null },
		rejectOnError: true,
	});

	if (!data.localPageLocation) throw new NotFoundError();

	return {
		items: data.localPageLocation.victoriousPetitionsConnection.nodes,
		cursor: data.localPageLocation.victoriousPetitionsConnection.pageInfo.endCursor,
		hasNextPage: data.localPageLocation.victoriousPetitionsConnection.pageInfo.hasNextPage,
		totalCount: data.localPageLocation.victoriousPetitionsConnection.totalCount,
		totalCountLocalized: data.localPageLocation.victoriousPetitionsConnection.totalCountLocalized,
	};
}

export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	return getData(utilityContext, slug);
}

export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData(utilityContext, slug, cursor);
}
